import Button from 'components/Button';
import Modal from 'components/Modal';
import { CurrencyKeyBoardRef } from 'components/NumberKeyBoard/Currency';
import { DISCOUNT_VALUE_TYPE } from 'features/settingService/services/constants';
import { useRef, useState } from 'react';
import AmountDiscountKeyboard from './AmountDiscountKeyboard';

type Props = {
  onSubmit?: (type: DISCOUNT_VALUE_TYPE, value: number) => void;
};

const ButtonApplyDiscountItem = ({ onSubmit = () => undefined }: Props) => {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<undefined | number | null>(null);
  const currencyRef = useRef<CurrencyKeyBoardRef>(null);
  const [discountValueType, setDiscountValueType] = useState(DISCOUNT_VALUE_TYPE.PERCENT);
  const handleClose = () => setVisible(false);
  const [resetKey, setResetKey] = useState(0);

  const _onSubmit = () => {
    onSubmit(discountValueType, value || 0);
    handleClose();
  };

  const onOpen = () => {
    setVisible(true);
    setValue(null);
    setDiscountValueType(DISCOUNT_VALUE_TYPE.PERCENT);
    setResetKey((x) => x + 1);
  };

  return (
    <>
      <Button className='custom-button' height={3} ntype='ORANGE' onClick={onOpen}>Apply Discount Items</Button>
      <Modal
        v2
        modalTitle='Apply Discount Items' okTitle='OK'
        visible={visible}
        onClose={handleClose} onSubmit={_onSubmit}
        noneBodyStyle
        noneFooterStyle
        width={800}
      >
        <AmountDiscountKeyboard
          key={resetKey}
          value={value} 
          onChange={setValue}
          discountValueType={discountValueType}
          setDiscountValueType={setDiscountValueType}
        />
      </Modal>
    </>
  );
};

export default ButtonApplyDiscountItem;
